export interface RequestType {
    request: string,
    success: string,
    failure: string
}

export function createRequestType(name: string): RequestType {
  return {
    request: `${name}_REQUEST`,
    success: `${name}_SUCCESS`,
    failure: `${name}_FAILURE`,
  };
}
